import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, AlertForm, AlertRedirect, MascaraCNPJ } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";
import { DataGrid } from "@material-ui/data-grid";
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
// import 'mdbreact/dist/css/mdb.css';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  BtVoltar,
  TextoExplicacaoCasinha,
  ListaFiltroMes,
  BtFiltroMesAtivo,
  BtFiltroMes,
  LinhaResultadoFornada,
  DataAtualizacaoFornada,
  DivTabelaRelatorio,
  BtVerRelatorioCompleto,
  ItemListaBusca,
  BgModal,
  ModalEvento
} from './Estilos'

import IcoBusca from './Images/ico_search_branco.png'
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function Omnichannel(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ IdUser, setIdUser ] = useState(localStorage.getItem("id_tb_user"));
  const [ CPFUser, setCPFUser ] = useState(localStorage.getItem("c_cpf"));
  const [ Tipo, setTipo ] = useState(localStorage.getItem("c_tipo"));
  const [ Cargo, setCargo ] = useState(localStorage.getItem("c_cargo"));

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Omnichannel")
    }
  }, []);






  const [ PesquisaExtratoDetalhes, setPesquisaExtratoDetalhes ] = useState([]);
  const [ ListaOmnionchannel, setListaOmnionchannel ] = useState([]);
  const [ NumPedidos, setNumPedidos ] = useState(0);
  const [ NumClientesNovos, setNumClientesNovos ] = useState(0);
  const [ NumClientesRecorrentes, setNumClientesRecorrentes ] = useState(0);
  const [ NumClientesMultiplosPedidos, setNumClientesMultiplosPedidos ] = useState(0);

  function BuscaDadosFornada(mesSelecionado, anoSelecionado) {

    var d = new Date();
    var mes = d.getMonth() + 1;
    var ano = d.getFullYear();
    
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    
    fetch(`${URLBunge}/api/Indicadores/ListarChannel/`+CPFUser+"/"+anoSelecionado+"/"+mesSelecionado, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result)    
        if(result.sucesso === true) {


          setPesquisaExtratoDetalhes(PesquisaExtratoDetalhes => [...PesquisaExtratoDetalhes, {
            NumClientesNovos: result.clientesNovos,
            NumClientesRecorrentes: result.clientesRecorrentes,
            NumClientesMultiplosPedidos: result.clientesMultiplosPedidos,
            NumPedidos: result.pedidos
          }])

          setListaOmnionchannel(result.listaChannel);
          setNumPedidos(result.pedidos);
          setNumClientesNovos(result.clientesNovos);
          setNumClientesRecorrentes(result.clientesRecorrentes);
          setNumClientesMultiplosPedidos(result.clientesMultiplosPedidos);
          setDataAtualizacao(result.data);
          setExisteDados(result.sucesso);
          setCarregandoResultado(false);
        } else {
          setExisteDados(result.sucesso);
          setMensagemBack(result.mensagem);
          setCarregandoResultado(false);
        }

      })
      .catch(error => console.log('error', error));

  }

  function MostraDataAtualizacao() {
    var dia = DataAtualizacao.substr(8,2);
    var mes = DataAtualizacao.substr(5,2);
    var ano = DataAtualizacao.substr(0,4);
    return <>{dia}/{mes}/{ano}</>;
  }













  const [ NumClientesCarteira, setNumClientesCarteira ] = useState(0);
  const [ NumClientesCadastrados, setNumClientesCadastrados ] = useState(0);
  const [ NumPercentualCadastro, setNumPercentualCadastro ] = useState(0);
  const [ NumClientesCadastrosMes, setNumClientesCadastrosMes ] = useState(0);
  const [ NumclientesComCompras, setNumclientesComCompras ] = useState(0);
  const [ DataAtualizacao, setDataAtualizacao ] = useState(0);
  const [ MensagemBack, setMensagemBack ] = useState("");
  const [ ExisteDados, setExisteDados ] = useState(false);



  function MostraDataAtualizacao() {
    var dia = DataAtualizacao.substr(8,2);
    var mes = DataAtualizacao.substr(5,2);
    var ano = DataAtualizacao.substr(0,4);
    return <>{dia}/{mes}/{ano}</>;
  }

  const [MesesAno, setMesesAno] = useState([]);

  useEffect(() => {

    var d = new Date();
    var dia = d.getDate();
    var mes = d.getMonth() + 1;
    var ano = d.getFullYear();
    var ano2 = d.getFullYear().toString().substr(-2);

    var startDate = "6-21";
    var month = parseInt(startDate.split("-")[0]);
    var year = parseInt(startDate.split("-")[1]);
    
    while(!(year === Number(ano2) && month === mes)){

      if(month<12){
        month++;
      } else {
         month = 1;
         year++;
      }
      var MesAno;
      if(month == 1)  { MesAno = 'JAN'; }
      if(month == 2)  { MesAno = 'FEV'; }
      if(month == 3)  { MesAno = 'MAR'; }
      if(month == 4)  { MesAno = 'ABR'; }
      if(month == 5)  { MesAno = 'MAI'; }
      if(month == 6)  { MesAno = 'JUN'; }
      if(month == 7)  { MesAno = 'JUL'; }
      if(month == 8)  { MesAno = 'AGO'; }
      if(month == 9)  { MesAno = 'SET'; }
      if(month == 10) { MesAno = 'OUT'; }
      if(month == 11) { MesAno = 'NOV'; }
      if(month == 12) { MesAno = 'DEZ'; }

      MesesAno.push({
        id: month+'20'+year,
        Mes: MesAno,
        Ano: '20'+year
      });

    }
    
    // console.log(MesesAno);

    setMesRelatorio(mes);
    setAnoRelatorio(ano);
    BuscaDadosFornada(mes, ano);

  },[]);

  useEffect(() => {
    setMesSelecionado(MesesAno[MesesAno.length-1].id)
  },[MesesAno]);


  const BtMes = ( item ) => (
      MesSelecionado == item.id ?
        <BtFiltroMesAtivo>{item.Mes}<span>{item.Ano}</span></BtFiltroMesAtivo>
      :
        <BtFiltroMes onClick={()=>SelecionaMes(item.Mes, item.Ano, item.id)}>{item.Mes}<span>{item.Ano}</span></BtFiltroMes>
  );

  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  const [MesSelecionado, setMesSelecionado] = useState();

  function SelecionaMes(Mes, Ano, Id) {
      setMesSelecionado(Id);

      var MesAno = 0;
      if(Mes == 'JAN') { MesAno = 1; }
      if(Mes == 'FEV') { MesAno = 2; }
      if(Mes == 'MAR') { MesAno = 3; }
      if(Mes == 'ABR') { MesAno = 4; }
      if(Mes == 'MAI') { MesAno = 5; }
      if(Mes == 'JUN') { MesAno = 6; }
      if(Mes == 'JUL') { MesAno = 7; }
      if(Mes == 'AGO') { MesAno = 8; }
      if(Mes == 'SET') { MesAno = 9; }
      if(Mes == 'OUT') { MesAno = 10; }
      if(Mes == 'NOV') { MesAno = 11; }
      if(Mes == 'DEZ') { MesAno = 12; }

      // console.log(MesAno + ' - ' + Ano);

      BuscaDadosFornada(MesAno, Ano);
      setMesRelatorio(MesAno);
      setAnoRelatorio(Ano);

  }


  const [CarregandoResultado, setCarregandoResultado] = useState(true);
  function LoadResultado() {
    return <>
    <div>Carregando...</div>
    </>
  }







  function FecharRelatorio() {
    setRelatorioMostra(false);
    setCarregandoBusca(true);
    setDadosRelatorioFlatlist([]);
  }

  const [RelatorioMostra, setRelatorioMostra] = useState(false);
  const [CarregandoBusca, setCarregandoBusca] = useState(true);
  const [DadosRelatorioFlatlist, setDadosRelatorioFlatlist] = useState([]);

  const [ MesRelatorio, setMesRelatorio ] = useState(0);
  const [ AnoRelatorio, setAnoRelatorio ] = useState(0);

  function MostraRelatorioDetalhado() {

    setRelatorioMostra(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Indicadores/ListarChannelDetalhado/`+CPFUser+"/"+AnoRelatorio+"/"+MesRelatorio, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result);
        setDadosRelatorioFlatlist(result.detalhes);
        setCarregandoBusca(false)
      })
      .catch(error => console.log('error', error));

  }





  // <View style={Estilos.BtDadosClienteLista}>
  // <Text style={[Estilos.NomeCliente, {textTransform: 'uppercase'}]}>{item.razaoSocial}</Text>
  // <View style={Estilos.ViewCNPJSAP}>
  //   <Text style={[Estilos.TextoCNPJSAP, {width: 68}]}>CPNJ</Text>
  //   <Text style={Estilos.TextoDadosCliente}>{item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")}</Text>
  // </View>
  // <View style={Estilos.ViewCNPJSAP}>
  //   <Text style={[Estilos.TextoCNPJSAP, {width: 68}]}>PEDIDO</Text>
  //   <Text style={Estilos.TextoDadosCliente}>{item.numeroPedido}</Text>
  // </View>
  // <View style={Estilos.ViewCNPJSAP}>
  //   <Text style={[Estilos.TextoCNPJSAP, {width: 68}]}>DATA</Text>
  //   <Text style={Estilos.TextoDadosCliente}>{MostraMes(item.mes)}/{item.ano}</Text>
  // </View>      
  // <View style={Estilos.ViewCNPJSAP}>
  //   <Text style={[Estilos.TextoCNPJSAP, {width: 68}]}>TIPO</Text>
  //   <Text style={Estilos.TextoDadosCliente}>{item.tipo}</Text>
  // </View>
  // </View>


  function MostraMes(Mes) {

    var MesAno = '';
    if(Mes == 1)  { MesAno = 'JAN'; }
    if(Mes == 2)  { MesAno = 'FEV'; }
    if(Mes == 3)  { MesAno = 'MAR'; }
    if(Mes == 4)  { MesAno = 'ABR'; }
    if(Mes == 5)  { MesAno = 'MAI'; }
    if(Mes == 6)  { MesAno = 'JUN'; }
    if(Mes == 7)  { MesAno = 'JUL'; }
    if(Mes == 8)  { MesAno = 'AGO'; }
    if(Mes == 9)  { MesAno = 'SET'; }
    if(Mes == 10) { MesAno = 'OUT'; }
    if(Mes == 11) { MesAno = 'NOV'; }
    if(Mes == 12) { MesAno = 'DEZ'; }
    
    return <>{MesAno}</>

  }  


  const renderItem = ( item, index ) => (
    <ItemListaBusca key={index} style={{cursor: 'default'}}>
        <div className={'NomeCliente'}>{item.razaoSocial}</div>
        <div className={'CNPJSAP'}><span style={{width: 50, marginRight: 5}}>CPNJ</span> {MascaraCNPJ(item.cnpj)}</div>
        <div className={'CNPJSAP'}><span style={{width: 50, marginRight: 5}}>PEDIDO</span> {item.numeroPedido}</div>
        <div className={'CNPJSAP'}><span style={{width: 50, marginRight: 5}}>DATA</span> {MostraMes(item.mes)}/{item.ano}</div>
        <div className={'CNPJSAP'}><span style={{width: 50, marginRight: 5}}>TIPO</span> {item.tipo}</div>
    </ItemListaBusca>
  );

  function RelatorioDetalhado(props) {
    return <>
        <BgModal>
        <ModalEvento>
            <div className={'TituloEvento'}>Relatório detalhado</div><Clear />
            <div className={'ListaClientes'} style={{textAlign: 'left'}}>
                <>                    
                    {CarregandoBusca == true ?
                    <LoadResultado />
                    :
                    DadosRelatorioFlatlist.length > 0 ?
                      DadosRelatorioFlatlist.map((item, index) => {
                        return renderItem(item, index)
                      })
                    :
                    <div>Nenhum cliente encontrado{'\n'}Verifique sua busca e tente novamente.</div>
                    }
                </>
            </div>
            <a className={'BtFecharModal'} onClick={()=>FecharRelatorio()}>FECHAR</a>
        </ModalEvento>
        </BgModal>
    </>
  }







  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>

        { RelatorioMostra == true ? <RelatorioDetalhado /> : null }
        
            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Omnichannel</TitNoticias>
                    <Clear />

                    <BtVoltar onClick={()=>history.push({ pathname: '/home', state: { } })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                      <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                    </BtVoltar>
                    <Clear />

                    <br/>

                    <ListaFiltroMes> { MesesAno.map((item, index) => { return BtMes(item) }) } </ListaFiltroMes>
                      <br />


                    {CarregandoResultado == true ?
                      <LoadResultado />
                    :
                    ExisteDados === false ?
                      <div>{MensagemBack}</div>
                    :
                    <>  
                      <DivTabelaRelatorio style={{maxWidth: 500}}>
                        <MDBTable>
                          <MDBTableHead>
                            <tr>
                              <th>Novos</th>
                              <th>Recorrentes</th>
                              <th>Múltiplos</th>
                              <th>Pedidos</th>
                            </tr>
                          </MDBTableHead>
                          <MDBTableBody>
                            <tr>
                              <td>{NumClientesNovos}</td>
                              <td>{NumClientesRecorrentes}</td>
                              <td>{NumClientesMultiplosPedidos}</td>
                              <td>{NumPedidos}</td>
                            </tr>
                          </MDBTableBody>
                        </MDBTable>
                      </DivTabelaRelatorio>

                      <BtVerRelatorioCompleto onClick={()=>MostraRelatorioDetalhado()}> <InfoOutlinedIcon /> <div>Ver relatório detalhado</div></BtVerRelatorioCompleto>

                      <DataAtualizacaoFornada>Data da atualização: {MostraDataAtualizacao()}</DataAtualizacaoFornada>

                      <Clear />
                    </>

                    }
                      





                    <TextoExplicacaoCasinha>
                    {Tipo == '7' || Tipo == '2479' ?
                        <>
                          Todo pedido realizado via Omnichannel gera pontos para o ranking e moedas:<br/>
                          Para pedidos de clientes novos, usuário ganha 3 pontos + 3 moedas;<br/>
                          Para um novo pedido do mesmo cliente o usuário ganha 2 pontos + 2 moedas;<br/>
                          Os usuários com mais pontos acumulados dentro do Omnichannel no mês, ganham adicional conforme colocação:<br/>
                          1º colocado = 5 pontos + 5 moedas<br/>
                          2º colocado =  3 pontos + 3 moedas<br/>
                          3º colocado = 2 pontos + 2 moedas
                        </>
                      :
                        <>
                          Todo pedido realizado via Omnichannel gera moedas:<br/>
                          Para pedidos de clientes novos, usuário ganha 3 moedas;<br/>
                          Para um novo pedido do mesmo cliente o usuário ganha 2 moedas;<br/>
                          Os usuários com mais moedas acumulados dentro do Omnichannel no mês, ganham adicional conforme colocação:<br/>
                          1º colocado = + 5 moedas<br/>
                          2º colocado =  + 3 moedas<br/>
                          3º colocado =   + 2 moedas
                        </>
                    }
                    </TextoExplicacaoCasinha>

                    
                </div>  
            </ColunaRegras>
            
            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default Omnichannel;
